<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">{{routeName}}</a>
      <button class="navbar-toggler navbar-burger"
              type="button"
              @click="toggleSidebar"
              :aria-expanded="$sidebar.showSidebar"
              aria-label="Toggle navigation">
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="ti-panel"></i>
              <p>Stats</p>
            </a>
          </li>
          <drop-down class="nav-item"
                     title="5 Notifications"
                     title-classes="nav-link"
                     icon="ti-bell">
            <a class="dropdown-item" href="#">Notification 1</a>
            <a class="dropdown-item" href="#">Notification 2</a>
            <a class="dropdown-item" href="#">Notification 3</a>
            <a class="dropdown-item" href="#">Notification 4</a>
            <a class="dropdown-item" href="#">Another notification</a>
          </drop-down>
          <drop-down
            class="nav-item"
            title="Racks"
            title-classes="nav-link"
            icon="ti-layout-grid3-alt"
          >
            <a v-on:click.prevent="createNewRack()" class="dropdown-item">Make New Rack</a>
          
          </drop-down>
          <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="ti-settings"></i>
              <p>
                Settings
              </p>
            </a>
          </li>
        </ul>
      </div>
    </div></nav>
</template>
<script>
import * as shelveOrderService from "../../services/shelveOrder.service";
import { createEmptySpaceArr } from "../../helpers/emptyRacks";

export default {
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    }
  },
  data() {
    return {
      activeNotifications: false
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    createNewRack: function() {
      console.log("NEW RACK!!");
      const alpha = Array.from(Array(26)).map((e, i) => i + 65);
      const alphabet = alpha.map((x) => String.fromCharCode(x));
      shelveOrderService.getBins().then(response => {
        console.log(response);
        if (response.items.error) {
          throw new Error(response.items.error);
        } else {
          let myRacks = JSON.parse(response.items[0]['rackMaps']);
          console.log(myRacks);
          let rackNumber = Object.keys(myRacks).length;
          console.log(rackNumber);
          let rackLocation = alphabet[rackNumber];
          console.log("New Rack Location: " + rackLocation);
          let barcodeArr = createEmptySpaceArr(15);
          console.log("Barcode Array before creating barcodes");
          console.log(JSON.stringify(barcodeArr));
          let arrCounter = 0;
          for (let i=0; i < barcodeArr.length; i++) {
            for (let j=0; j < barcodeArr[i].length; j++) {
              arrCounter += 1;
              let currBarcode = `OP-${rackLocation}-`;
              let zeros;
              if (arrCounter.toString().length == 1) {
                zeros = "00000";
              } else {
                zeros = "0000";
              }
              currBarcode = currBarcode + zeros + arrCounter;
              //let newBarcode = JsBarcode("#barcode", currBarcode);

              barcodeArr[i][j] = currBarcode;
            }
          }
          console.log("Barcode Array after creating barcodes");
          console.log(JSON.stringify(barcodeArr));
          let allRacks;
          if (response.items.length > 0) {
            allRacks = myRacks;
            
            allRacks[rackLocation] = {
              spaceArr: createEmptySpaceArr(0),
              used: 0,
              barcodes: barcodeArr,
              together: {}
            } 
          } else {
            allRacks = {};
            allRacks[rackLocation] = {
              spaceArr: createEmptySpaceArr(0),
              used: 0,
              barcodes: barcodeArr,
              together: {}
            }
          }
          console.log("All Racks");
          console.log(allRacks);
          shelveOrderService.updateRacks(allRacks).then(response => {
            console.log(response);
            //this.toShelve.barcode = "";
          }).catch((err) => {
            console.log("Error Updating Racks:::: " + JSON.stringify(err.message));
            //this.setUpWarning(JSON.stringify(err.message));
          });
        }
      }).catch((err) => {
        console.log("Error Grabbing/Creating Racks:::: " + JSON.stringify(err.message));
        //this.setUpWarning(JSON.stringify(err.message));
      });
    }
  }
};
</script>
<style>
</style>
